import { useCallback, useState } from "react";
import { startAuthentication } from "@simplewebauthn/browser";
import { useNavigate } from "react-router-dom";
import { useAuth } from "providers/AuthProvider";

export const usePasskeyLogin = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const loginWithPasskey = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await fetch( `${process.env.REACT_APP_BACKEND_URL}/auth/passkey/login/options`, { method: "POST" } );
      if (!response.ok) throw new Error("Could not create authentication options.");
      const options = await response.json();
      const { challengeId, ...authenticationOptions } = options;
      const credential = await startAuthentication({ optionsJSON: authenticationOptions });
      const verifyResponse = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/auth/passkey/login/verify`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            credential,
            challengeId
          })
        }
      );
      const result = await verifyResponse.json();
      if (!verifyResponse.ok) throw new Error(result.message);
      login( result.userId, result.token );
      navigate("/");
    } catch (err) {
      if (err.name === "NotAllowedError") {
        console.log("Passkey authentication cancelled.");
        return;
      }
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  }, [login, navigate]);

  return {
    loginWithPasskey,
    isLoading,
  };
};